import type { ISVGIconProps } from "@ab.uitools/ui-library/components/SVGIcons/types";
import classNames from "classnames";

export const AEDSymbolIcon = ({
  size,
  type,
  className = "",
  onClick,
  refHandler,
  id,
  dataId,
}: ISVGIconProps) => {
  return (
    <svg
      className={classNames("svg-icon", {
        [`svg-icon__size-${size}`]: size,
        [`svg-icon__type-${type}`]: type,
        [className]: className,
      })}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
      ref={refHandler}
      id={id}
      data-id={dataId ? `${dataId}-svg-icon` : ""}
    >
      <path
        d="M5.79338 3.00089C6.15236 3.00089 6.44338 3.2919 6.44338 3.65088V11.0289C6.44338 11.3879 6.15236 11.6789 5.79338 11.6789C5.43439 11.6789 5.14338 11.3879 5.14338 11.0289V3.65088C5.14338 3.2919 5.43439 3.00089 5.79338 3.00089Z"
        fill="#888888"
      />
      <path
        d="M14.1915 7.04245C14.5122 6.88115 14.9029 7.01038 15.0642 7.33109C15.5064 8.21025 16.1132 9.7539 16.2822 11.0295C16.3656 11.6585 16.1183 12.1968 15.714 12.563C15.3235 12.9167 14.7967 13.1063 14.2684 13.129C13.6219 13.1567 12.7922 13.1552 12.1336 12.8649C11.7843 12.7109 11.4551 12.4642 11.2383 12.0798C11.0228 11.698 10.9556 11.2467 11.0074 10.7492C11.0446 10.3921 11.3641 10.1328 11.7212 10.17C12.0782 10.2071 12.3376 10.5267 12.3004 10.8838C12.2688 11.1877 12.3202 11.352 12.3705 11.441C12.4193 11.5275 12.5028 11.6069 12.658 11.6753C13.0085 11.8298 13.5555 11.8584 14.2126 11.8302C14.4821 11.8186 14.7065 11.7216 14.8413 11.5994C14.9625 11.4897 15.015 11.3628 14.9935 11.2002C14.851 10.1248 14.3114 8.72752 13.9028 7.91519C13.7415 7.59449 13.8707 7.20374 14.1915 7.04245Z"
        fill="#888888"
      />
      <path
        d="M7.03135 12.7548C6.76869 12.6852 6.33901 12.6306 5.88932 12.6844C5.44397 12.7377 4.87598 12.9114 4.48158 13.4015C4.23424 13.7089 4.08387 14.0575 4.05865 14.4442C4.03306 14.8365 4.15 15.1901 4.38171 15.4687C4.41405 15.5075 4.44799 15.5442 4.48327 15.5788L4.08727 15.7552C3.75936 15.9013 3.61197 16.2856 3.75807 16.6135C3.90418 16.9414 4.28844 17.0888 4.61635 16.9427L6.2882 16.1978C6.37455 16.1593 6.44838 16.1043 6.50763 16.0382C6.68122 16.0013 6.85013 15.9477 7.00879 15.8783L7.47426 15.6747C7.80316 15.5309 7.95315 15.1476 7.80928 14.8187C7.66541 14.4898 7.28216 14.3398 6.95327 14.4837L6.48779 14.6873C6.19912 14.8136 5.83574 14.8304 5.58265 14.7505C5.46171 14.7124 5.40367 14.6644 5.38117 14.6373C5.3684 14.622 5.35134 14.5986 5.35589 14.5289C5.3615 14.4429 5.39215 14.3436 5.49438 14.2165C5.58963 14.0982 5.76878 14.0081 6.04378 13.9752C6.31446 13.9428 6.57835 13.9796 6.69822 14.0114C7.04522 14.1034 7.40109 13.8966 7.49308 13.5496C7.58508 13.2026 7.37835 12.8468 7.03135 12.7548Z"
        fill="#888888"
      />
      <path
        d="M9.18465 13.0797C9.5649 13.0797 9.87315 12.7731 9.87315 12.3949C9.87315 12.0167 9.5649 11.7101 9.18465 11.7101C8.80439 11.7101 8.49614 12.0167 8.49614 12.3949C8.49614 12.7731 8.80439 13.0797 9.18465 13.0797Z"
        fill="#888888"
      />
    </svg>
  );
};
